export function isElement<T extends HTMLElement = HTMLElement>(elt?: any): elt is T {
  return typeof window !== 'undefined' && elt instanceof HTMLElement
}
